export class UserLoginModel{
    login: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/models/user/userlogin.model.ts